import React, { createContext, FC, ReactNode, useContext } from 'react'

import { LibraWorkflow } from './workflow/workflowStepsApi'

interface WorkflowContextType {
  workflow: LibraWorkflow
}

const WorkflowContext = createContext<WorkflowContextType | undefined>(
  undefined
)

interface WorkflowProviderProps {
  workflow: LibraWorkflow
  children: ReactNode
}

export const WorkflowProvider: FC<WorkflowProviderProps> = ({
  workflow,
  children,
}) => {
  return (
    <WorkflowContext.Provider value={{ workflow }}>
      {children}
    </WorkflowContext.Provider>
  )
}

export const useWorkflow = (): LibraWorkflow => {
  const context = useContext(WorkflowContext)
  if (context === undefined) {
    throw new Error('useWorkflow must be used within a WorkflowProvider')
  }
  return context.workflow
}
